"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var RecordsAddEditController = /*#__PURE__*/function (_PageController) {
  function RecordsAddEditController() {
    var _this2;
    _classCallCheck(this, RecordsAddEditController);
    _this2 = _callSuper(this, RecordsAddEditController);
    var _this = _this2;
    _this2.dropzoneExternalFilesEl = "#dropzoneExternalFiles";
    _this2.itemRowEl = "tr.item";
    _this2.blockItemsEl = "#items";
    _this2.itemPriceInputEl = "input.item-price";
    _this2.itemPiecesInputEl = "input.item-pieces";
    _this2.itemDiscountPercentageInputEl = "input.item-discount-percentage";
    _this2.itemTotalPricePerItemWithoutVatBeforeDiscountInputEl = "input.total-price-per-item-without-vat-before-discount";
    _this2.itemTotalPricePerItemWithoutVatAfterDiscountInputEl = "input.total-price-per-item-without-vat-after-discount";
    _this2.totalPriceBeforeDiscountWithoutVatEl = 'input[name="total_price_before_discount_without_vat"]';
    _this2.totalPriceBeforeDiscountWithoutVatTextEl = 'input[name="total_price_before_discount_without_vat_text"]';
    _this2.totalPriceAfterDiscountWithoutVatEl = 'input[name="total_price_after_discount_without_vat"]';
    _this2.totalPriceAfterDiscountWithoutVatTextEl = 'input[name="total_price_after_discount_without_vat_text"]';
    _this2.totalPriceAfterDiscountWithVatEl = 'input[name="total_price_after_discount_with_vat"]';
    _this2.totalPriceAfterDiscountWithVatTextEl = 'input[name="total_price_after_discount_with_vat_text"]';
    _this2.vatEl = 'select[name="vat"]';
    _this2.depositPercentageEl = 'input[name="deposit_percentage"]';
    _this2.depositPercentageTextEl = 'input[name="deposit_percentage_text"]';
    _this2.depositTotalEl = 'input[name="deposit_total"]';
    _this2.depositTotalTextEl = 'input[name="deposit_total_text"]';
    _this2.depositFinalEl = 'input[name="deposit_final"]';
    _this2.depositFinalTextEl = 'input[name="deposit_final_text"]';
    _this2.selectLangEl = 'select[name="langs"]';
    _this2.buyerNameEl = '.buyer-name';
    _this2.buyerNameTextEl = 'input[name="buyer_name_text"]';
    _this2.buyerCustomerType = 'select[name="customerType"]';
    _this2.buyerEmailEl = 'input[name="buyer_contact_person_email"]';
    _this2.buyerPhoneNumberEl = 'input[name="buyer_contact_person_phone_number"]';
    _this2.buyerFirstNameEl = 'input[name="buyer_contact_person_first_name"]';
    _this2.buyerLastNameEl = 'input[name="buyer_contact_person_last_name"]';
    _this2.buyerICEl = 'input[name="buyer_ic"]';
    _this2.buyerDICEl = 'input[name="buyer_dic"]';
    _this2.buyerStreetEl = 'input[name="buyer_street"]';
    _this2.buyerCityEl = 'input[name="buyer_city"]';
    _this2.buyerPostNumberEl = 'input[name="buyer_post_number"]';
    _this2.buyerPostCountryEl = 'input[name="buyer_country"]';
    _this2.currenciesSelectEl = "select.select-currencies";
    _this2.characterCurrencyEl = ".character-currency";
    _this2.addNewItemEl = "#add-item-line";
    _this2.totalPriceBeforeDiscountWithoutVat = 0;
    _this2.totalPriceAfterDiscountWithoutVat = 0;
    _this2.totalPriceAfterDiscountWithVat = 0;
    _this2.watchChangeCurrency();
    _this2.selectedCurrency;
    _this2.watchInputsForRecalculateItemTotalPrice();
    _this2.watchChangeVat();
    _this2.watchChangeDepositPercentage();
    _this2.initTinyMce();
    _this2.watchAddNewItem();
    _this2.rerenderSelectedCurrency($(_this2.currenciesSelectEl).val());
    _this2.watchChangeLang();
    _this2.updateListOfBuyerBasedOnSearchTerm();
    _this2.initChangeOrderItemsRows();
    _this2.watchReinitItemsWysiwygOnAjax();
    $(_this.itemPriceInputEl).trigger("change");
    return _this2;
  }
  _inherits(RecordsAddEditController, _PageController);
  return _createClass(RecordsAddEditController, [{
    key: "watchChangeLang",
    value: function watchChangeLang() {
      var _this = this;
      $(document).on("change", _this.selectLangEl, function () {
        var idLang = $(this).val();
        console.log(settings);
        tinymce.activeEditor.setContent(settings.additional_information[idLang].value);
        tinymce.activeEditor.save();
        $(_this.totalPriceBeforeDiscountWithoutVatTextEl).val(settings.total_price_before_discount_without_vat[idLang].value);
        $(_this.totalPriceAfterDiscountWithoutVatTextEl).val(settings.total_price_after_discount_without_vat[idLang].value);
        $(_this.totalPriceAfterDiscountWithVatTextEl).val(settings.total_price_after_discount_with_vat[idLang].value);
        $(_this.depositTotalTextEl).val(settings.deposit_total[idLang].value);
        $(_this.depositFinalTextEl).val(settings.deposit_final[idLang].value);
        $(_this.depositPercentageTextEl).val(settings.deposit_percentage[idLang].value);

        //            $('textarea[name="additional_information_text"]').val(settings.additional_information[idLang].value).trigger("change");
      });
    }
  }, {
    key: "initTinyMce",
    value: function initTinyMce() {
      tinymce.init({
        selector: '#custom-text',
        toolbar: "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent | forecolor",
        setup: function setup(editor) {
          editor.on('change', function () {
            editor.save();
          });
        }
      });
      this.initItemsWysiwyg();
    }

    // Per-row WYSIWYG editors are kept separate so they can be torn down and
    // rebuilt: sorting moves <tr> nodes (which reloads the TinyMCE <iframe> and
    // wipes it) and an AJAX snippet redraw after a form error replaces the DOM
    // the editors live in.
  }, {
    key: "initItemsWysiwyg",
    value: function initItemsWysiwyg() {
      // Remove any stale editors first so a re-init never double-binds a textarea.
      tinymce.remove('.notes-wysiwyg');
      tinymce.init({
        selector: '.notes-wysiwyg',
        toolbar: "bold italic",
        menubar: false,
        statusbar: false,
        resize: false,
        max_height: 228,
        newline_behavior: 'linebreak',
        content_style: "body { font-size: 12px;font-family: monospace; line-height: 1; margin: 4px; }",
        setup: function setup(editor) {
          editor.on('change', function () {
            editor.save();
          });
        }
      });
    }
  }, {
    key: "watchAddNewItem",
    value: function watchAddNewItem() {
      var _this = this;
      $(document).on("click", _this.addNewItemEl, function () {
        console.log(_this.itemRowEl + ".hide-row:first-of-type");
        $(_this.itemRowEl + ".hide-row", _this.blockItemsEl).first().removeClass("hide-row");
      });
    }

    // When the record form is submitted over AJAX and comes back with an error
    // (e.g. createEditRecord threw, so the presenter redraws the 'form' snippet
    // instead of redirecting), the replaced DOM holds plain textareas again.
    // Flush the editors before sending and rebuild them after the redraw.
  }, {
    key: "watchReinitItemsWysiwygOnAjax",
    value: function watchReinitItemsWysiwygOnAjax() {
      var _this = this;
      $.nette.ext("reinitItemsWysiwyg", {
        before: function before() {
          if (window.tinymce) {
            tinymce.triggerSave();
          }
        },
        success: function success(payload) {
          if (!window.tinymce || !payload || !payload.snippets) {
            return;
          }

          // Only rebuild when a redrawn snippet actually carries WYSIWYG fields.
          for (var snippetId in payload.snippets) {
            if (payload.snippets[snippetId].indexOf("notes-wysiwyg") !== -1) {
              _this.initItemsWysiwyg();
              break;
            }
          }
        }
      });
    }
  }, {
    key: "updateListOfBuyerBasedOnSearchTerm",
    value: function updateListOfBuyerBasedOnSearchTerm() {
      var _this = this;
      var select2 = $(_this.buyerNameEl).select2({
        tags: true,
        selectOnBlur: true,
        templateResult: function templateResult(state) {
          if (state.loading) {
            return state.text;
          }
          if ('name' in state) {
            var $state = $('<span style="line-height: 1.2"><strong>' + state.name + '</strong> (IČ:' + state.ic + ')<br>' + 'Adresa:' + state.street + ", " + state.city + ", " + state.post_number + '</span>');
          } else {
            var $state = $('<span>' + state.text + '</span>');
          }
          return $state;
        },
        ajax: {
          delay: 250,
          url: updateBuyersListBaseOnSearchTermUrl,
          data: function data(params) {
            return {
              searchTerm: params.term
            };
          },
          contentType: "application/x-www-form-urlencoded;charset=utf-8",
          processResults: function processResults(data) {
            return {
              results: data
            };
          }
        }
      });
      select2.on("select2:select", function (e) {
        var data = e.params.data;
        var currentBuyerCustomerTypeId = $(_this.buyerCustomerType).val();
        $(_this.buyerEmailEl).val(data.contact_person_email);
        $(_this.buyerCustomerType).val(data.customer_type_id === null || data.customer_type_id === undefined ? currentBuyerCustomerTypeId === "" ? $(_this.buyerCustomerType).attr("data-default-value") : currentBuyerCustomerTypeId : data.customer_type_id);
        $(_this.buyerNameTextEl).val(data.text);
        $(_this.buyerPhoneNumberEl).val(data.contact_person_phone_number);
        $(_this.buyerFirstNameEl).val(data.contact_person_first_name);
        $(_this.buyerLastNameEl).val(data.contact_person_last_name);
        $(_this.buyerICEl).val(data.ic);
        $(_this.buyerDICEl).val(data.dic);
        $(_this.buyerStreetEl).val(data.street);
        $(_this.buyerCityEl).val(data.city);
        $(_this.buyerPostNumberEl).val(data.post_number);
        $(_this.buyerPostCountryEl).val(data.country);
      });
    }
  }, {
    key: "watchChangeCurrency",
    value: function watchChangeCurrency() {
      var _this = this;
      $(_this.currenciesSelectEl).change(function () {
        _this.rerenderSelectedCurrency($(this).val());
      });
    }
  }, {
    key: "rerenderSelectedCurrency",
    value: function rerenderSelectedCurrency(selectedIdCurrency) {
      var _this = this;
      _this.selectedCurrency = currencies[selectedIdCurrency];
      $(_this.characterCurrencyEl).html(_this.selectedCurrency.currency_char);
    }

    // ============== ITEM PRICES ===========
  }, {
    key: "watchInputsForRecalculateItemTotalPrice",
    value: function watchInputsForRecalculateItemTotalPrice() {
      var _this = this;
      $(_this.itemPriceInputEl + "," + _this.itemPiecesInputEl + "," + _this.itemDiscountPercentageInputEl).change(function () {
        var itemRow = $(this).parents(_this.itemRowEl);
        _this.recalculateItemTotalPrice(itemRow);
        _this.recalculateTotalPrice();
      });
    }
  }, {
    key: "addVatToNumber",
    value: function addVatToNumber(vat, number) {
      vat = Number(vat);
      return number * (vat / 100 + 1);
    }
  }, {
    key: "recalculateTotalPrice",
    value: function recalculateTotalPrice() {
      var _this = this;
      this.totalPriceBeforeDiscountWithoutVat = 0;
      this.totalPriceAfterDiscountWithoutVat = 0;
      this.totalPriceAfterDiscountWithVat = 0;
      $(_this.itemRowEl).each(function () {
        var itemTotalPricePerItemWithoutVatBeforeDiscountInputEl = $(_this.itemTotalPricePerItemWithoutVatBeforeDiscountInputEl, $(this));
        var itemTotalPricePerItemWithoutVatAfterDiscountInputEl = $(_this.itemTotalPricePerItemWithoutVatAfterDiscountInputEl, $(this));
        var itemTotalPricePerItemWithoutVatBeforeDiscount = 0;
        var itemTotalPricePerItemWithoutVatAfterDiscount = 0;
        var itemTotalPricePerItemWithoutVatBeforeDiscountRaw = itemTotalPricePerItemWithoutVatBeforeDiscountInputEl.attr("data-price-number");
        var itemTotalPricePerItemWithoutVatAfterDiscountRaw = itemTotalPricePerItemWithoutVatAfterDiscountInputEl.attr("data-price-number");
        if (!isNaN(Number(itemTotalPricePerItemWithoutVatBeforeDiscountRaw))) {
          itemTotalPricePerItemWithoutVatBeforeDiscount = Number(itemTotalPricePerItemWithoutVatBeforeDiscountRaw);
        }
        if (!isNaN(Number(itemTotalPricePerItemWithoutVatAfterDiscountRaw))) {
          itemTotalPricePerItemWithoutVatAfterDiscount = Number(itemTotalPricePerItemWithoutVatAfterDiscountRaw);
        }
        _this.totalPriceBeforeDiscountWithoutVat += itemTotalPricePerItemWithoutVatBeforeDiscount;
        _this.totalPriceAfterDiscountWithoutVat += itemTotalPricePerItemWithoutVatAfterDiscount;
      });
      $(_this.totalPriceBeforeDiscountWithoutVatEl).val(_this.totalPriceBeforeDiscountWithoutVat.toFixed(2));
      $(_this.totalPriceAfterDiscountWithoutVatEl).val(_this.totalPriceAfterDiscountWithoutVat.toFixed(2));

      // CALCULCATE VAT
      _this.totalPriceAfterDiscountWithVat = _this.addVatToNumber($(_this.vatEl).val(), _this.totalPriceAfterDiscountWithoutVat);
      $(_this.totalPriceAfterDiscountWithVatEl).val(_this.totalPriceAfterDiscountWithVat.toFixed(2));

      // CALCULATES DEPOSITS
      var depositePercentage = Number($(_this.depositPercentageEl).val());
      var depositeTotal = _this.totalPriceAfterDiscountWithVat / 100 * depositePercentage;
      var depositeFinal = _this.totalPriceAfterDiscountWithVat - _this.totalPriceAfterDiscountWithVat / 100 * depositePercentage;
      $(_this.depositTotalEl).val(depositeTotal.toFixed(2));
      $(_this.depositFinalEl).val(depositeFinal.toFixed(2));
    }
  }, {
    key: "watchChangeVat",
    value: function watchChangeVat() {
      var _this = this;
      $(_this.vatEl).change(function () {
        _this.recalculateTotalPrice();
      });
    }
  }, {
    key: "watchChangeDepositPercentage",
    value: function watchChangeDepositPercentage() {
      var _this = this;
      $(_this.depositPercentageEl).change(function () {
        _this.recalculateTotalPrice();
      });
    }
  }, {
    key: "convertNumberToCurrency",
    value: function convertNumberToCurrency(number) {
      var fixedDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      return new Intl.NumberFormat('cs-CZ').format(number);
    }
  }, {
    key: "recalculateItemTotalPrice",
    value: function recalculateItemTotalPrice(itemRow) {
      var _this = this;
      var price = 0;
      var pieces = 0;
      var discountPercentage = 0;
      var itemTotalPricePerItemWithoutVatBeforeDiscountRaw = 0;
      var itemTotalPricePerItemWithoutVatAfterDiscountRaw = 0;
      var itemPriceInputEl = $(_this.itemPriceInputEl, itemRow);
      var itemPiecesInputEl = $(_this.itemPiecesInputEl, itemRow);
      var itemDiscountPercentageInputEl = $(_this.itemDiscountPercentageInputEl, itemRow);
      var itemTotalPricePerItemWithoutVatBeforeDiscountInputEl = $(_this.itemTotalPricePerItemWithoutVatBeforeDiscountInputEl, itemRow);
      var itemTotalPricePerItemWithoutVatAfterDiscountInputEl = $(_this.itemTotalPricePerItemWithoutVatAfterDiscountInputEl, itemRow);
      var priceInputValueRaw = itemPriceInputEl.val();
      var piecesInputValueRaw = itemPiecesInputEl.val();
      var discountPercentageInputValueRaw = itemDiscountPercentageInputEl.val();
      if (!isNaN(Number(priceInputValueRaw))) {
        price = Number(priceInputValueRaw);
      }
      if (!isNaN(Number(piecesInputValueRaw))) {
        pieces = Number(piecesInputValueRaw);
      }
      if (!isNaN(Number(discountPercentageInputValueRaw))) {
        discountPercentage = Number(discountPercentageInputValueRaw);
      }
      itemTotalPricePerItemWithoutVatBeforeDiscountRaw = price * pieces;
      itemTotalPricePerItemWithoutVatAfterDiscountRaw = itemTotalPricePerItemWithoutVatBeforeDiscountRaw;
      if (price > 0 && pieces > 0 && discountPercentage > 0) {
        itemTotalPricePerItemWithoutVatAfterDiscountRaw = (price - price / 100 * discountPercentage) * pieces;
      }
      itemTotalPricePerItemWithoutVatBeforeDiscountInputEl.val(itemTotalPricePerItemWithoutVatBeforeDiscountRaw.toFixed(2));
      itemTotalPricePerItemWithoutVatBeforeDiscountInputEl.attr("data-price-number", itemTotalPricePerItemWithoutVatBeforeDiscountRaw.toFixed(2));
      itemTotalPricePerItemWithoutVatAfterDiscountInputEl.val(itemTotalPricePerItemWithoutVatAfterDiscountRaw.toFixed(2));
      itemTotalPricePerItemWithoutVatAfterDiscountInputEl.attr("data-price-number", itemTotalPricePerItemWithoutVatAfterDiscountRaw.toFixed(2));
    }
  }, {
    key: "initChangeOrderItemsRows",
    value: function initChangeOrderItemsRows() {
      var el = document.getElementById('items-table');
      var _this = this;
      _this.sortable = new Sortable(el, {
        animation: 150,
        // ms, animation speed moving items when sorting, `0` — without animation
        easing: "cubic-bezier(1, 0, 0, 1)",
        // Easing for animation. Defaults to null. See https://easings.net/ for examples.
        handle: ".handle-sorting",
        //draggable: ".item",  // Specifies which items inside the element should be draggable

        //revert: true,
        //forceFallback: (_this.isSafari() ? true : false),
        onStart: function onStart() {
          // Persist editor content into the textareas and drop the editors
          // before the <tr> is moved, otherwise the TinyMCE <iframe> reloads
          // mid-drag and the WYSIWYG content is lost.
          if (window.tinymce) {
            tinymce.triggerSave();
            tinymce.remove('.notes-wysiwyg');
          }
        },
        onEnd: function onEnd(/**Event*/evt) {
          // Rebuild the editors from the (preserved) textarea content.
          _this.initItemsWysiwyg();
          if (evt.oldIndex !== evt.newIndex) {
            $(".item", el).each(function () {
              var row = $(this);
              var rowOrder = row.index();
              var itemOrderEl = $(".item-order", row);
              itemOrderEl.val(rowOrder);
            });
          }
        }
      });
    }
  }]);
}(PageController);
function deleteItem(el) {
  console.log("x");
  var link = $(el).attr("data-link");
  var parentWrapperEl = $(el).parents(".item");
  var messageRaw = $(el).attr("data-message");
  if (confirm(messageRaw)) {
    $.nette.ajax({
      url: link,
      type: 'GET',
      complete: function complete(jqXHR, textStatus) {
        parentWrapperEl.remove();
        $("input.item-price").trigger("change");
      }
    });
  }
}
function deleteItemFiles(el) {
  var link = $(el).attr("data-link");
  var parentWrapperEl = $(el).parents(".wrapper-item-file");
  var messageRaw = $(el).attr("data-message");
  if (confirm(messageRaw)) {
    $.nette.ajax({
      url: link,
      type: 'GET',
      complete: function complete(jqXHR, textStatus) {
        parentWrapperEl.remove();
      }
    });
  }
}